"use client"

import Title from "@/components/common/Typography/Title"
import { useDefaultFontSize } from "@/hooks/app/useDefaultFontSize"
import { useDevicePassedWidth } from "@/hooks/app/useDevicePassedWidth"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useAppDispatch } from "@/lib/redux/hooks"
import { hotelActions } from "@/lib/redux/features/hotel/reduce"
import { getQueryStringSearchHotel } from "@/utils/hotel/getQueryStringSearchHotel"
import { Col, Row } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import Link from "@/components/common/LinkNext"

const RecommendedHotels = () => {
  const isDesktop = useIsDesktop()
  const screenWidth = useDevicePassedWidth(screenWidth => screenWidth)
  const defaultFontSize = useDefaultFontSize()
  const [baseHeight, setBaseHeight] = useState(0)

  const dispatch = useAppDispatch()
  const { t, i18n } = useTranslation()

  useEffect(() => {
    if (baseHeight !== 0) return;
    setBaseHeight((screenWidth > (114 * defaultFontSize) ? 114 * defaultFontSize : (typeof window === 'undefined' ? 0 : window.innerWidth)) / 3)
  }, [screenWidth, baseHeight])

  return (
    <>
      <Row>
        <Title level={3} style={{ marginTop: 0 }}>
          {t("hotel.favorite_foreign_destination")}
        </Title>
      </Row>
      <Row>
        <div style={{ '--base-height': `20rem`, display: baseHeight > 0 ? undefined : 'none' } as any} className={`hotels__recommended--container ${isDesktop ? "hotels__recommended--desktop" : "hotels__recommended--mobile"}`}>
          {[
            {
              background: "/static/images/recommended_hotels/1_long.png",
              name: "Singapore",
              description: "",
              destinationId: 'cities_17182',
              location: {
                "id": 4064,
                "displayName": "Singapore",
                "localeDisplayType": "Singapore",
                "numsHotel": 1326,
                "country": 114,
                "type": [
                  "CITY",
                  "destination"
                ],
                "searchType": "CITY",
                "isDomestic": false,
                "isActive": true,
                "address": {
                  "countryCode": 114,
                  "cityName": "Singapore",
                  "cityId": 4064
                },
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Singapore",
                  "en": "Singapore"
                },
                "slug": "singapore",
                "tagName": [],
                "labelLang": "Singapore",
                "_id": "cities_4064"
              }
            },
            {
              background: "/static/images/recommended_hotels/1.png",
              name: "Bangkok",
              destinationId: 'cities_16440',
              location: {
                "id": 9395,
                "displayName": "Bangkok",
                "localeDisplayType": "Bangkok",
                "numsHotel": 12048,
                "country": 106,
                "type": [
                  "CITY",
                  "destination"
                ],
                "searchType": "CITY",
                "isDomestic": false,
                "isActive": true,
                "address": {
                  "countryCode": 106,
                  "cityName": "Bangkok",
                  "cityId": 9395
                },
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Bangkok",
                  "en": "Bangkok"
                },
                "slug": "bangkok",
                "tagName": [],
                "labelLang": "Bangkok",
                "_id": "cities_9395"
              }
              // description: "Hội An là một thành phố trực thuộc tỉnh Quảng Nam, Việt Nam. Phố cổ Hội An từng là một thương cảng quốc tế sầm uất, gồm những di sản kiến trúc đã có từ hàng trăm năm trước."
            },
            {
              background: "/static/images/recommended_hotels/2.png",
              name: "Seoul",
              description: "",
              destinationId: 'cities_16552',
              location: {
                "id": 14690,
                "displayName": "Seoul",
                "localeDisplayType": "Seoul",
                "numsHotel": 5945,
                "country": 212,
                "type": [
                  "CITY",
                  "destination"
                ],
                "searchType": "CITY",
                "isDomestic": false,
                "isActive": true,
                "address": {
                  "countryCode": 212,
                  "cityName": "Seoul",
                  "cityId": 14690
                },
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Seoul",
                  "en": "Seoul"
                },
                "slug": "seoul",
                "tagName": [],
                "labelLang": "Seoul",
                "_id": "cities_14690"
              }
            },
            {
              background: "/static/images/recommended_hotels/2_long.png",
              name: "Tokyo",
              description: "",
              destinationId: 'cities_2758',
              location: {
                "id": 5085,
                "displayName": "Tokyo",
                "localeDisplayType": "Tokyo",
                "numsHotel": 12486,
                "country": 3,
                "type": [
                  "CITY",
                  "destination"
                ],
                "searchType": "CITY",
                "isDomestic": false,
                "isActive": true,
                "address": {
                  "countryCode": 3,
                  "cityName": "Tokyo",
                  "cityId": 5085
                },
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Tokyo",
                  "en": "Tokyo"
                },
                "slug": "tokyo",
                "tagName": [],
                "labelLang": "Tokyo",
                "_id": "cities_5085"
              }
            },
            {
              background: "/static/images/recommended_hotels/3_long.png",
              name: "Thượng hải",
              description: "",
              destinationId: 'cities_13170',
              location: {
                "id": 3987,
                "displayName": "Shanghai",
                "localeDisplayType": "Thượng Hải",
                "numsHotel": 13832,
                "country": 191,
                "type": [
                  "CITY",
                  "destination"
                ],
                "searchType": "CITY",
                "isDomestic": false,
                "isActive": true,
                "address": {
                  "countryCode": 191,
                  "cityName": "Shanghai",
                  "cityId": 3987
                },
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Thượng Hải",
                  "en": "Shanghai"
                },
                "slug": "thuong-hai",
                "tagName": [],
                "labelLang": "Thượng Hải",
                "_id": "cities_3987"
              }
            },
            {
              background: "/static/images/recommended_hotels/3.png",
              name: "Maldives",
              description: "",
              destinationId: 'cities_3738',
              location: {
                "id": 34,
                "displayName": "Maldives",
                "localeDisplayType": "Maldives",
                "country": 34,
                "type": [
                  "COUNTRY",
                  "destination"
                ],
                "searchType": "COUNTRY",
                "isActive": true,
                "supplier": "agoda",
                "nameLang": {
                  "vi": "Maldives",
                  "en": "Maldives"
                },
                "slug": "maldives",
                "tagName": [],
                "_id": "contries_34"
              }
            }
          ].map(({ background, name, description, location }) => {
            const now = dayjs().add(30, 'day')
            const nextThreeDays = now.add(1, 'day')

            return (
              <Row
                key={location._id}
                className="hotels__recommended--item"
                style={{
                  background: `url("${background}") center center / cover no-repeat`
                }}
                align='bottom'
              >
                <Col span={24} className="hotels__recommended--item-box">
                  <Link
                    href={`/hotels/result/search/name_${name}-loc_${location.id}-adt_2-chd_0-inf_0-in_${now.format('YYYYMMDD')}-out_${nextThreeDays.format('YYYYMMDD')}-room_1-type_CITY`}
                    onClick={(e) => {
                      e.preventDefault()
                      e.stopPropagation()
                      dispatch(hotelActions.selectDestination(location))
                      dispatch(hotelActions.selectDateCheckIn(now.format('YYYY-MM-DD')))
                      dispatch(hotelActions.selectDateCheckOut(nextThreeDays.format('YYYY-MM-DD')))

                      const searchString = getQueryStringSearchHotel()
                      window.open(
                        `/${i18n.language}/hotels/result?${searchString}`, `_blank`
                      )
                    }}
                  >
                    <Row>
                      <Col span={24}>
                        <Row>
                          <Title style={{ marginTop: 0 }} className="hotels__recommended--name" level={isDesktop ? 3 : 5}>
                            {name}
                          </Title>
                        </Row>
                        <Row>
                          <Title className="hotels__recommended--location" level={5} style={{ marginTop: 0, marginBottom: description ? "0.5rem" : "0px" }}>
                            {location.numsHotel} {t("common.hotel")}
                          </Title>
                        </Row>
                        {description && (
                          <Row>
                            <Title ellipsis={{ rows: isDesktop ? 4 : 2 }} className="hotels__recommended--description" level={5} style={{ margin: 0 }}>
                              {description}
                            </Title>
                          </Row>
                        )}
                      </Col>
                    </Row>
                  </Link>

                </Col>
              </Row>
            )
          })}
        </div>
      </Row>
    </>
  )
}

export default RecommendedHotels